import { render, staticRenderFns } from "./ServiceTitanSetUp.vue?vue&type=template&id=c950c1a4&scoped=true"
import script from "./ServiceTitanSetUp.vue?vue&type=script&lang=js"
export * from "./ServiceTitanSetUp.vue?vue&type=script&lang=js"
import style0 from "./ServiceTitanSetUp.vue?vue&type=style&index=0&id=c950c1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c950c1a4",
  null
  
)

export default component.exports